import { observer } from 'mobx-react-lite'
import styles from './styles.module.scss'

export const CompliancePage = observer(() => {
  return <div className={styles.wrap}>not found</div>
})
